import { render, staticRenderFns } from "./PendingApprovals.vue?vue&type=template&id=f0225384&scoped=true&"
import script from "./PendingApprovals.vue?vue&type=script&lang=js&"
export * from "./PendingApprovals.vue?vue&type=script&lang=js&"
import style0 from "./PendingApprovals.vue?vue&type=style&index=0&id=f0225384&lang=scss&scoped=true&"
import style1 from "./PendingApprovals.vue?vue&type=style&index=1&id=f0225384&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0225384",
  null
  
)

export default component.exports